export default function temVirgula(texto) {
    return texto.includes(",");
  }